<template>
    <focus-lock>
        <div
            role="dialog"
            aria-modal="true"
            aria-labelledby="cz2-modal-header"
            class="cz2__modal-popup cz2__warning-modal"
            :class="{
                'cz2__modal-popup--blue': blue,
            }"
            @click="overlayClick"
        >
            <div
                class="cz2__modal-popup__body"
                :style="bodyStyle"
            >
                <button
                    v-if="showCloseButton"
                    class="cz2__modal-popup__close"
                    :aria-label="$t('ACTION_CLOSE')"
                    @click.prevent="close"
                />

                <div class="cz2__modal-popup__body-content">
                    <h1>
                        <div
                            v-if="superTitle?.length > 0"
                            class="cz2__modal-popup__super-header"
                        >
                            {{superTitle}}
                        </div>

                        <div
                            v-if="title?.length > 0"
                            id="cz2-modal-header"
                            class="cz2__modal-popup__header"
                        >
                            {{title}}
                        </div>
                    </h1>

                    <slot />
                </div>

                <div
                    :class="{ stacked: stackButtons }"
                    class="cz2__modal-popup__actions"
                >
                    <btn
                        v-if="secondaryCTAText"
                        secondary
                        @click="cancel"
                    >
                        {{secondaryCTAText}}
                    </btn>

                    <btn
                        v-if="primaryCTAText"
                        black
                        :error="error"
                        @click="confirm"
                        class="cz2__btn--primary-cta"
                    >
                        {{primaryCTAText}}
                    </btn>
                </div>
            </div>
        </div>
    </focus-lock>
</template>

<style lang="scss">
    @import "../../style/variables.scss";

    #cz2.cz2 {
        .cz2__warning-modal {
            text-align: center;

            z-index: 100000;

            @include respond-above(md) {
                .cz2__btn {
                    height: 60px;
                }

                .cz2__btn:hover,
                .cz2__btn:focus {
                    font-size: 20px;
                }
            }

            .cz2__modal-popup__actions {
                button {
                    width: 100%;
                    max-width: 320px;
                }

                &.stacked {
                    flex-direction: column-reverse;
                    gap: 16px;
                    padding: 0 48px;
                    align-items: center;
                }
            }
        }
    }

    #cz2.cz2.cz2__is-kiosk {
        .cz2__modal-popup--blue {
            .cz2__btn--primary-cta {
                background-color: color(secondaryYellow);
                color: black;
            }
        }
    }
</style>

<script>
    import FocusLock from 'vue-focus-lock';

    import Btn from './Btn.vue';

    export default {
        components: {
            FocusLock,
            Btn,
        },

        props: {
            superTitle: {
                type: String,
                default: null,
            },
            title: {
                type: String,
                default: null,
            },
            primaryCTAText: {
                type: String,
                default: null,
            },
            secondaryCTAText: {
                type: String,
                default: null,
            },
            stackButtons: {
                type: Boolean,
                default: false,
            },
            error: {
                type: Boolean,
                default: false,
            },
            blue: {
                type: Boolean,
                default: false,
            },
            showCloseButton: {
                type: Boolean,
                default: true,
            },
            bodyStyle: {
                type: Object,
                default: () => {},
            },
        },

        computed: {
            isKiosk() {
                return this.$store.state.customizer.options.isKiosk;
            },
        },

        methods: {
            close() {
                this.$emit('close');
            },

            cancel() {
                this.$emit('cancel');
            },

            confirm() {
                this.$emit('confirm');
            },

            overlayClick(event) {
                if (event.target === this.$el) {
                    this.$emit('overlayClick');
                }
            },
        },
    };
</script>
